const docToQuizFeedbacks = ['Generate more', 'Funnier', 'Easier', 'Harder', 'More question types']
const aiSlidesGeneratorFeedbacks = ['Generate more', 'Funnier', 'Easier', 'Harder']

export default {
  docToQuizFeedbacks,
  aiSlidesGeneratorFeedbacks,
}
